<div class="subBlockContainer" id="enduseraddressbook">
  <child-header [title]="title" (closeEvent)="close()" [showAdd]="true" titleAdd="New End User" (addEvent)="addNewEndUser()"></child-header>
  <div class="subBlockContent scroll">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <!-- <div class="title blade-title-font">
          {{title}}
          <div id="buttonNew" class="basic-icon add-icon" (click)="addNewEndUser()"></div>
        </div> 
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
        <p class="page-title-description">
          Save your most commonly used delivery locations here so next time you go through the check-out
          process you don't have to manually enter the delivery location information.
        </p>
        <div class="filter-wrapper">
          <div class="col-md-6">
            <div class="searchInputGroup ">
              <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
              </div>
              <input class="searchInput" placeholder="Filter" onfocus="this.placeholder=''"
                onblur="this.placeholder='Filter'" type="text" [(ngModel)]="filterInput"
                (ngModelChange)="searchEndUserAddressBook()">
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-deliveryLoc.png"></div>
          <div id="reason">We couldn't find any saved addresses for your account.</div>
          <button class="button button-red button-large" (click)="addNewEndUser()">Create now</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!hasEmptyFilterResult">
        <div class="top-divider"></div>
        <div class="child-body">
          <div class="shared-outer-wrapper" *ngFor="let endUserAddressBook of endUserAddressBooksFilter">
          <section>
            <div class="basic-icon edit-icon" (click)="editEndUserAddressBook(endUserAddressBook)"></div>
            <div class="payment-name-wrapper">{{endUserAddressBook?.out_display_name}}</div>
            <div>{{endUserAddressBook?.out_company_name}}</div>
            <div>{{endUserAddressBook?.out_email}}</div>
            <div>{{endUserAddressBook?.out_mobile}}</div>
            <div>{{endUserAddressBook?.out_phone}}</div>
            <div>{{endUserAddressBook?.out_fax}}</div>
            <div>
              <span>{{endUserAddressBook?.out_address_1}}</span>
              <span>{{endUserAddressBook?.out_address_2}}</span>
              <span>{{endUserAddressBook?.out_address_3}}</span>
              <span>{{endUserAddressBook?.out_address_4}}</span>
              <span>{{endUserAddressBook?.out_address_5}}</span>
            </div>
            <div>
              <span>{{endUserAddressBook?.out_suburb}}</span>
              <span>{{endUserAddressBook?.out_state}}</span>
              <span>{{endUserAddressBook?.out_country}}</span>
            </div>
            <div>{{endUserAddressBook?.out_postcode}}</div>
          </section>
        </div>
      </div>
      </ng-container>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
<ng-container #entry>
  <router-outlet></router-outlet>
</ng-container>